import {createStore} from 'easy-peasy';
import companyListing from './companyListing.store';

export const store = createStore({
    companyListing: companyListing,
});
